type CopyCallback = (isCopied: boolean) => void;

const copyToClipboard = async (
	text: string,
	onCopy: () => void,
	setIsCopied: CopyCallback
) => {

	if (navigator.clipboard) {
		try {
			await navigator.clipboard.writeText(text);
 			onCopy();
			setIsCopied(true);
			setTimeout(() => {
				setIsCopied(false);
			}, 2000);
		} catch (error) {
			console.error("Failed to copy using Clipboard API:", error);
		}
	} else {
 		const textarea = document.createElement("textarea");
		document.body.appendChild(textarea);
		textarea.value = text;
		textarea.select();
		try {
			document.execCommand("copy");
 			onCopy();
			setIsCopied(true);
			setTimeout(() => {
				setIsCopied(false);
			}, 2000);
		} catch (error) {
			console.error("Failed to copy using fallback method:", error);
		}
		document.body.removeChild(textarea);
	}
};
export default copyToClipboard;
